// Dates and "what's next" for the year of ready-made emails in library.ts.

import { libraryEmails, yearPlan, type PlannedEmail } from './library';

export const WELCOME_PREFIX = 'welcome-';
export const WELCOME_TAG = 'new-client';
export const WELCOME_NAME = 'Welcome series';

export const yearEmails = (): PlannedEmail[] => yearPlan().filter((p) => !p.key.startsWith(WELCOME_PREFIX));
export const welcomeEmails = (): PlannedEmail[] => yearPlan().filter((p) => p.key.startsWith(WELCOME_PREFIX)).sort((a, b) => a.sendDay - b.sendDay);
export const findPlanned = (key: string): PlannedEmail | undefined => yearPlan().find((p) => p.key === key) ?? libraryEmails().find((p) => p.key === key);

/** Suggested send date as YYYY-MM-DD. The year comes from the key prefix. Null for welcome emails. */
export function planDate(p: PlannedEmail): string | null {
  if (p.key.startsWith(WELCOME_PREFIX) || !p.month) return null;
  const year = Number(p.key.slice(0, 4));
  if (!year) return null;
  return `${year}-${String(p.month).padStart(2, '0')}-${String(Math.max(1, p.sendDay)).padStart(2, '0')}`;
}

/**
 * The next planned email Jen hasn't used yet. Anything suggested up to `graceDays` ago still counts,
 * so an email due last week shows as "a little late" instead of vanishing.
 */
export function upNext(plan: PlannedEmail[], used: Set<string>, today: string, graceDays = 10): PlannedEmail | null {
  const cutoff = addDays(today, -graceDays);
  for (const p of plan) {
    const d = planDate(p);
    if (!d || used.has(p.key)) continue;
    if (d >= cutoff) return p;
  }
  return null;
}

export function addDays(day: string, n: number): string {
  const t = new Date(`${day}T12:00:00Z`);
  t.setUTCDate(t.getUTCDate() + n);
  return t.toISOString().slice(0, 10);
}

/** Whole days from `from` to `to` (both YYYY-MM-DD). Negative when `to` is earlier. */
export function daysBetween(from: string, to: string): number {
  return Math.round((Date.parse(`${to}T12:00:00Z`) - Date.parse(`${from}T12:00:00Z`)) / 86_400_000);
}
